import {
    Box,
    Button,
    useMediaQuery,
    useTheme,
  } from "@mui/material";
  import React, { useEffect, useRef, useState } from "react";
  import Grid from "@mui/material/Grid";
  import SelectComponent from "../../components/SelectComponent/SelectComponent"; 
  import { useDispatch, useSelector } from "react-redux";
  import {
    setExtraProductData,
    setIsBackToHoreca,
    setIsOpenWidget,
    setLanguageID,
    setLanguageWords,
    updateDefaultLanguage,
    updateEventDates,
    updateEventOrStdTicketTypesData,
    updateEventsOrStandardTickets,
    updateSelectedDate,
    updateStdDates,
  } from "../../store/slice/Ticketing.slice";
  
  import { useLocation, useNavigate } from "react-router-dom";
  import {
    FetchWidgetConfigDetails,
    GetGuestDetailsByKey,
    getExtraProductDetails,
    getLanguageDetails,
    getWidgetSettings,
    getWidgetTitleandInfo,
  } from "../../api/HorecaWidget.service";
  import {
    setLanguageLoaded,
    updateButtonText,
    updateGuestInfo,
    updateKey,
    updateLanguageData,
    updateWidgetConfig,
    updateWidgetSetting,
  } from "../../store/slice/widgetSetting.slice";
  import customParseFormat from "dayjs/plugin/customParseFormat";
  import dayjs from "dayjs";
  import { setCombinationList } from "../../store/slice/Activity.slice";
  import { getCombinationList } from "../../api/activity.service";
  import Time from "../ticketingWidget/Time";
  import EventComponent from "../ticketingWidget/Event";
  import {
    fetchEventOrStandardTicketsTypes,
    fetchEventTicketsDates,
    fetchStandardTicketsDates,
    getEventsOrStandardTickets,
  } from "../../api/ticketing.service";
  import CalendarTicket from "../ticketingWidget/CalenderTicket";
  import MultipleEventCalaenderView from "../ticketingWidget/MultipleEventCalaenderView";
  import EventOrStandardReservationType from "../ticketingWidget/EventOrStandardReservationType";
  dayjs?.extend(customParseFormat); // Extend for custom date format parsing
  
  let loadSettings = null;
  let widgetIdSettings = null;

const TicketingComponent = ({data,language}) => {
    const [widgetLoading, setWidgetLoading] = useState(false);
    const [langLoading, setLangLoading] = useState(false);
    const theme = useTheme();
    const {
      totalCount,
      EventDates,
      selectedDate,
      reservType,
      adult,
      child,
      kid,
      baby,
      toddler,
      isBackToHoreca,
      defaultLanguage,
      languageWords,
      isOpenWidget,
      SelectedEventOrStdResType
    } = useSelector((store) => store.Ticketing);
  
    const {
      widgetConfig,
      languageData,
      languageLoaded,
      guestId
    } = useSelector((store) => store?.widgetSettings);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [reservTypeLoading, setReserveTypeLoading] = useState(false);
    const [isEventOpen, setIsEventOpen] = useState(false);
    const eventRef = useRef(null);
    const dateRef = useRef(null);
    const reservationType = useRef(null);
    const timeRef = useRef(null);
    const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
    const [isReservationType, setIsReservationType] = useState(false);
    const [isTimeComponent, setIsTimeComponent] = useState(false);
    const [openWidget, setOpenWidget] = useState(
      location?.state?.openWidgetScreen ?? isOpenWidget
    );
  
    const fetchLanguageDetails = async () => {
      setLangLoading(true);
      try {
        const response = await getLanguageDetails(data?.key);
        if (response?.status != 200) {
          console.error("Error fetching language details widget:", response);
          return;
        }
        dispatch(updateLanguageData(response?.data));
        const langParam = queryParams.get("lang");
        if (response?.data) {
          const defaultLang =
            !language && !langParam
              ? response?.data?.find((item) => item?.defaultLanguage)?.langcode
              : langParam
              ? langParam
              : language;
  
          dispatch(updateDefaultLanguage(defaultLang));
          dispatch(setLanguageLoaded(true)); // Set the flag to true
          dispatch(setLanguageID(defaultLang?.idlanguage));
        }
        setLangLoading(false);
      } catch (error) {
        console.error("Error fetching language details widget:", error?.message);
        setLangLoading(false);
      }
    };
    const fetchWidgetSettings = async (language) => {
      try {
        const response = await getWidgetSettings(language, data?.key);
        if (response?.status !== 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget settings. Please try again later."
          );
        }
        loadSettings = response?.data;
        dispatch(updateWidgetSetting(response?.data));
      } catch (error) {
        const errorMsg =
          error?.message ||
          "An unexpected error occurred while fetching widget settings.";
        console.error("Error fetching widget settings:", errorMsg);
      }
    };
    const fetchWidgetTitleandInfo = async (widgetSetupId, language) => {
      try {
        const response = await getWidgetTitleandInfo(widgetSetupId, language);
        if (response?.status != 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget title and info. Please try again later."
          );
        }
        widgetIdSettings = response?.data;
      } catch (error) {
        console.error("Error fetching widget settings:", error?.message);
      }
    };
  
  
  
    const fetchEventOrStandardTickets = async () => {
      try {
        const response = await getEventsOrStandardTickets(
          data?.key,
          language,
          true,
          true
        );
     
        
          dispatch(updateEventsOrStandardTickets(response));
  
        
         // Assuming 'data' contains event or standard tickets data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching events or standard tickets:", error);
      }
    };
    const fetchStdDatesForEvent = async () => {
      try {
        const response = await fetchStandardTicketsDates(data?.key);
        dispatch(updateStdDates(response)); // Assuming 'data' contains standard dates data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching standard dates for event:", error);
      }
    };
    const fetchEventDates = async (id) => {
      try {
        const response = await fetchEventTicketsDates(id);
        dispatch(updateEventDates(response)); // Assuming 'data' contains standard dates data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching standard dates for event:", error);
      }
    };
  
    const fetchEventOrStdTicketTypes=async()=>{
      try {
        const response = await fetchEventOrStandardTicketsTypes( 
          data?.key,
          language,
          reservType?.eventTicketId,
          reservType?.isStandardTicket ?selectedDate : selectedDate?.availableDate,
          reservType?.isStandardTicket);
        dispatch(updateEventOrStdTicketTypesData(response)); // Assuming 'data' contains event or standard ticket types data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching event or standard ticket types:", error);
      }
    }
    const fetchExtraTicketProducts = async () => {
      try {
        const response = await getExtraProductDetails(
          SelectedEventOrStdResType?.idreservationtype,
          language
        );
        if (response?.status == 200) {
          dispatch(setExtraProductData(response?.data));
        }
      } catch (error) {
        console.log("error extra product", error?.message);
      }
    };
  
    const fetchWidgetSettingsDetails = async (lang) => {
      try {
        setWidgetLoading(true);
        const response = await FetchWidgetConfigDetails(data?.key, data?.idWidgetSetup,lang,guestId);
        if (response?.status != 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget settings details. Please try again later."
          );
        }
        const result = response?.data?.basicLanguages?.reduce((acc, item) => {
          const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
          const data = item.widgetTranslateLanguages[0]?.name;
          acc[tag] = data; // Assign data to the key acc[tag]
          return acc;
        }, {});
        dispatch(updateWidgetConfig(response?.data));
        dispatch(updateButtonText(response?.data?.fields?.reservationButtonText));
        dispatch(setLanguageWords(result));
        setWidgetLoading(false);
      } catch (error) {
        console.error("Error fetching widget settings details:", error);
        setWidgetLoading(false);
      }
    };
  
    const fetchGuestDetailsByToken=async()=>{
      try {
        const response=await GetGuestDetailsByKey(widgetConfig?.token,data?.key,guestId)
        if(!response){
          throw new Error("Failed to fetch guest details. Please try again later.")
        }
        dispatch(updateGuestInfo(response))
      } catch (error) {
        console.error("Error fetching guest details by token:", error);  
      }
    }
  
  
    useEffect(()=>{
      if(widgetConfig?.token){
        fetchGuestDetailsByToken()
      }
    },[widgetConfig])
    
    useEffect(() => {
      if(SelectedEventOrStdResType?.idreservationtype)
        fetchExtraTicketProducts();
    }, [SelectedEventOrStdResType]);
  
    const handleClose = () => {
      setOpenWidget(false);
    };
    useEffect(() => {
      if (data?.key && language) fetchEventOrStandardTickets();
    }, [language]);
    useEffect(() => {
        if(data?.key)
        fetchLanguageDetails();  
    }, [data?.key]);
    useEffect(() => {
       if(language)
        fetchWidgetSettings(language);
    }, [language]);
    useEffect(() => {
      if (language ) {
        // Checks if defaultLanguage is a non-empty string
        fetchWidgetSettingsDetails(language);
      }
    }, [language]);
    useEffect(() => {
      if (language)
        fetchWidgetTitleandInfo(data?.idWidgetSetup, language);
    }, [language]);
    useEffect(()=>{
      dispatch(updateKey(data?.key))
    },[data])
  
  
    useEffect(() => {
      if (Object.keys(reservType)?.length > 0) {
        if (reservType?.isStandardTicket) {
          fetchStdDatesForEvent();
        } else {
          fetchEventDates(reservType?.eventTicketId);
        }
      }
    }, [reservType]);
  
    useEffect(()=>{
      if(Object.keys(reservType)?.length > 0 && selectedDate) fetchEventOrStdTicketTypes()
    },[selectedDate])
  
  
    const fetchCombinations = async () => {
      dispatch(setCombinationList([]));
      const payload = {
        key: data?.key,
        idreservationtype: parseInt(SelectedEventOrStdResType?.idreservationtype),
        ArrivalDate: reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate,
        // ArrivalTime: '09:00',
        // DepatureTime:'12:00',
        Field1: parseInt(adult),
        Field2: parseInt(child),
        Field3: parseInt(kid),
        Field4: parseInt(toddler),
        Field5: parseInt(baby),
        LanguageCode: language,
        NoOfGuest: parseInt(totalCount),
      };
      try {
        const response = await getCombinationList(payload);
        dispatch(setCombinationList(response));
      } catch (error) {
        console.error(error);
      }
    };
    useEffect(() => {
       if(SelectedEventOrStdResType?.idreservationtype)
       fetchCombinations();
    }, [SelectedEventOrStdResType]);
  
    useEffect(()=>{
      if(EventDates?.length == 1){
        dispatch(updateSelectedDate(EventDates[0]));
      }
    },[EventDates])
  return (
    <Box>
                   <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SelectComponent
                      label={"Event"}
                      value={reservType?.eventTicketName || "Ticket"}
                      onClick={() => setIsEventOpen(!isEventOpen)}
                      ref={eventRef}
                      // disabled={totalCount > 0 ? false : true}
                      sx={{
                        position: "relative",

                        width: "100%",
                        height: "72px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          color: theme?.guest?.textColor,
                          ml: 3,
                          mt: 1,
                          fontSize: { sm: "12px", md: "14px" },
                        },
                      }}
                    />
                    <EventComponent
                      isOpen={isEventOpen}
                      handleClose={() => setIsEventOpen(false)}
                      Ref={eventRef.current}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SelectComponent
                      label={languageWords?.date}
                      value={
                       Object?.keys(reservType)?.length > 0 ? (reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate) : 'DD-MM-YYYY'
                      }
                      onClick={() => setIsDateDropdownOpen(!isDateDropdownOpen)}
                      ref={dateRef}
                      // disabled={Object?.keys(reservType) ? false : true}
                      //disabled={totalCount > 0 ? false : true}
                      sx={{
                        position: "relative",

                        width: "100%",
                        height: "72px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          color: theme?.guest?.textColor,
                          ml: 3,
                          mt: 1,
                          fontSize: { sm: "12px", md: "14px" },
                        },
                      }}
                      disabled={Object?.keys(reservType)?.length == 0 || (!reservType?.isStandardTicket && EventDates?.length == 1)}
                    />
                    {reservType?.isStandardTicket ? (
                      <CalendarTicket
                        isOpen={isDateDropdownOpen}
                        handleClose={() => setIsDateDropdownOpen(false)}
                        Ref={dateRef.current}
                      />
                    ) : (
                      <MultipleEventCalaenderView
                        isOpen={isDateDropdownOpen}
                        handleClose={() => setIsDateDropdownOpen(false)}
                        Ref={dateRef.current}
                      />
                    )}
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SelectComponent
                     label={languageWords?.reserveType}
                      value={
                        SelectedEventOrStdResType &&
                        typeof SelectedEventOrStdResType === "object" &&
                        Object.keys(SelectedEventOrStdResType).length > 0
                          ? SelectedEventOrStdResType?.name
                          : "Type"
                      }
                      onClick={() => {
                        setIsReservationType(!isReservationType);
                      }}
                      ref={reservationType}
                      disabled={selectedDate?.availableDate?.trim() != "" ? false : true}
                      sx={{
                        position: "relative",

                        width: "100%",
                        height: "72px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          color: theme?.guest?.textColor,
                          ml: 3,
                          mt: 1,
                          fontSize: { sm: "12px", md: "14px" },
                        },
                      }}
                    />
                    <EventOrStandardReservationType
                      isOpen={isReservationType}
                      handleClose={() => setIsReservationType(false)}
                      Ref={reservationType.current}
                      isLoading={reservTypeLoading}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SelectComponent
                      label={languageWords?.Time}
                      value={
                      Object(reservType)?.keys?.length > 0 || selectedDate  ? (reservType?.isStandardTicket ? reservType?.eventDateAndTime :  `${dayjs(selectedDate?.fromTime, "HH:mm:ss").format("HH:mm")}- ${dayjs(selectedDate?.toTime, "HH:mm:ss").format("HH:mm")}` ) : 'HH:MM'
                      }
                      onClick={() => setIsTimeComponent(!isTimeComponent)}
                      ref={timeRef}
                      sx={{
                        position: "relative",

                        width: "100%",
                        height: "72px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${theme?.widget?.inputBorderColor}`,
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          color: theme?.guest?.textColor,
                          ml: 3,
                          mt: 1,
                          fontSize: { sm: "12px", md: "14px" },
                        },
                      }}
                      disabled={true}
                    />
                    <Time
                      isOpen={isTimeComponent}
                      handleClose={() => setIsTimeComponent(false)}
                      Ref={timeRef.current}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        height: "70px",
                        backgroundColor:
                          reservType &&
                          typeof reservType === "object" &&
                          Object.keys(reservType).length > 0 &&
                          totalCount > 0 &&
                          selectedDate 
                            ? theme?.widget?.bookNowbtnBgActive
                            : theme?.widget?.bookNowBtnBg,
                        color:
                          reservType &&
                          typeof reservType === "object" &&
                          Object.keys(reservType).length > 0 &&
                          totalCount > 0 &&
                          selectedDate
                            ? theme?.widget?.booknowBtnTextColorActive
                            : theme?.widget?.booknowBtnTextColor,
                        fontWeight: "bold",
                        display: "flex", // Ensure flexbox is used
                        flexDirection: "column", // Align content in a column (Book Now on top, €25,00 below)
                        justifyContent: "center", // Center the text vertically
                        alignItems: "center", // Center the text horizontally
                      }}
                      onClick={() => {
                        if (
                          reservType &&
                          typeof reservType === "object" &&
                          Object.keys(reservType).length > 0 &&
                          totalCount > 0 &&
                          selectedDate 
                        ) {
                          navigate(`/bookNowTickets`);
                        } else {
                          return;
                        }
                      }}
                    >
                      {languageWords?.Booknow}
                      {reservType?.totalCost > 0 &&
                        totalCount < widgetConfig?.reservationRequestMin && (
                          <Box
                            component="span"
                            fontSize="13px"
                            fontWeight="200"
                          >
                            €{parseFloat(reservType?.totalCost).toFixed(2)}
                          </Box>
                        )}
                    </Button>
                  </Grid>
                </Grid>
      
    </Box>
  )
}

export default TicketingComponent
